/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Aggregation } from './Aggregation';
import {
    AggregationFromJSON,
    AggregationFromJSONTyped,
    AggregationToJSON,
    AggregationToJSONTyped,
} from './Aggregation';
import type { ResourceType } from './ResourceType';
import {
    ResourceTypeFromJSON,
    ResourceTypeFromJSONTyped,
    ResourceTypeToJSON,
    ResourceTypeToJSONTyped,
} from './ResourceType';
import type { WidgetResourceFilterRepresentation } from './WidgetResourceFilterRepresentation';
import {
    WidgetResourceFilterRepresentationFromJSON,
    WidgetResourceFilterRepresentationFromJSONTyped,
    WidgetResourceFilterRepresentationToJSON,
    WidgetResourceFilterRepresentationToJSONTyped,
} from './WidgetResourceFilterRepresentation';

/**
 * 
 * @export
 * @interface WidgetResourceRepresentation
 */
export interface WidgetResourceRepresentation {
    /**
     * 
     * @type {string}
     * @memberof WidgetResourceRepresentation
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetResourceRepresentation
     */
    name: string;
    /**
     * 
     * @type {ResourceType}
     * @memberof WidgetResourceRepresentation
     */
    type: ResourceType;
    /**
     * 
     * @type {Aggregation}
     * @memberof WidgetResourceRepresentation
     */
    aggregationOverGenerators: Aggregation;
    /**
     * 
     * @type {string}
     * @memberof WidgetResourceRepresentation
     */
    config: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetResourceRepresentation
     */
    timeCompare?: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetResourceRepresentation
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetResourceRepresentation
     */
    resourceKey?: string;
    /**
     * 
     * @type {Array<WidgetResourceFilterRepresentation>}
     * @memberof WidgetResourceRepresentation
     */
    resourceFilters?: Array<WidgetResourceFilterRepresentation>;
}



/**
 * Check if a given object implements the WidgetResourceRepresentation interface.
 */
export function instanceOfWidgetResourceRepresentation(value: object): value is WidgetResourceRepresentation {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('aggregationOverGenerators' in value) || value['aggregationOverGenerators'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function WidgetResourceRepresentationFromJSON(json: any): WidgetResourceRepresentation {
    return WidgetResourceRepresentationFromJSONTyped(json, false);
}

export function WidgetResourceRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetResourceRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'name': json['name'],
        'type': ResourceTypeFromJSON(json['type']),
        'aggregationOverGenerators': AggregationFromJSON(json['aggregationOverGenerators']),
        'config': json['config'],
        'timeCompare': json['timeCompare'] == null ? undefined : json['timeCompare'],
        'position': json['position'],
        'resourceKey': json['resourceKey'] == null ? undefined : json['resourceKey'],
        'resourceFilters': json['resourceFilters'] == null ? undefined : ((json['resourceFilters'] as Array<any>).map(WidgetResourceFilterRepresentationFromJSON)),
    };
}

export function WidgetResourceRepresentationToJSON(json: any): WidgetResourceRepresentation {
    return WidgetResourceRepresentationToJSONTyped(json, false);
}

export function WidgetResourceRepresentationToJSONTyped(value?: WidgetResourceRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'name': value['name'],
        'type': ResourceTypeToJSON(value['type']),
        'aggregationOverGenerators': AggregationToJSON(value['aggregationOverGenerators']),
        'config': value['config'],
        'timeCompare': value['timeCompare'],
        'position': value['position'],
        'resourceKey': value['resourceKey'],
        'resourceFilters': value['resourceFilters'] == null ? undefined : ((value['resourceFilters'] as Array<any>).map(WidgetResourceFilterRepresentationToJSON)),
    };
}

